import { combineEpics } from 'redux-observable';
import { fetchAllProductsEpic } from './fetch-all-products.epic';

export const combinedProductsEpics = combineEpics(
    fetchAllProductsEpic,
);
